import { consoleDev, ConsoleStatus, fetchData } from '@quizzach/utils';
import { useCallback, useState } from 'react';
import { MOCK_TV_CODE } from './mocks.config';
import { mockTvCode } from './tvCode.mock';

export const useTvCode = () => {
	const [code, setCode] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<boolean>(false);
	const [expiresAt, setExpiresAt] = useState<number | null>(null);

	const getCode = useCallback(async (uuid: string) => {
		if (MOCK_TV_CODE) {
			setLoading(true);
			window.setTimeout(() => {
				const mocked = mockTvCode();
				setCode(mocked.code);
				setExpiresAt(mocked.expires_at);
				setError(false);
				setLoading(false);
			}, 600);
			return;
		}
		try {
			setLoading(true);
			const response = await fetchData<ITvCode>(
				`/api/quizzes/${uuid}/quiz-codes`,
				{
					method: 'GET',
				},
				{ authRoute: true }
			);
			if (response.status >= 300) {
				consoleDev('getCode', ConsoleStatus.HTTP, response.status);
				setError(true);
			} else {
				consoleDev('getCode', ConsoleStatus.SUCC);
				setError(false);
				if (response.data) {
					setCode(response.data.code);
					setExpiresAt(response.data.expires_at ?? null);
				}
			}
		} catch (err) {
			consoleDev('getCode', ConsoleStatus.NET, err);
			setError(true);
		} finally {
			setLoading(false);
		}
	}, []);

	return {
		code,
		loading,
		error,
		expiresAt,
		setCode,
		setLoading,
		setError,
		getCode,
	};
};

interface ITvCode {
	code: string;
	expires_at: number;
}
